import './messages-route.component.js';

angular
.module('inkfinder')
.config(function($stateProvider, USER_ROLES) {
  $stateProvider
  .state('inkfinder.messages', {
    url: '/messages',
    abstract: true,
    views: {
      '@': {
        component: 'inkMessagesRoute'
      }
    },
    data: {
      authorizedRoles:
      [USER_ROLES.collector, USER_ROLES.operator, USER_ROLES.artist]
    }
  })
  .state('inkfinder.messages.inbox', {
    url: '/inbox?page',
    views: {
      messagesView: {
        component: 'inkMessages'
      }
    },
    params: {
      page: {
        value: '1',
        dynamic: true
      }
    },
    resolve: {
      participants: function(
        $stateParams, Participants, Session, GroupParticipants) {
        let collectorId = Session.collector.id;
        let conversationId;
        let appointmentId;
        let read = 'False';
        let page = $stateParams.page;
        let sort = 'last_message_date';
        let lastMessage = 'notnull';
        return Participants
        .get(
        conversationId,
        appointmentId,
        collectorId,
        read,
        page,
        sort,
        lastMessage)
        .then(function(participants) {
          return participants;
        });
      },
      messagesType: function() {
        return 'inbox';
      },
      $title: () => 'Messages - Inbox'
    },
    bindings: {
      $transition$: '<'
    }
  })
  .state('inkfinder.messages.archive', {
    url: '/archive?page',
    views: {
      messagesView: {
        component: 'inkMessages'
      }
    },
    params: {
      page: {
        value: '1',
        dynamic: true
      }
    },
    resolve: {
      participants: function(
        $stateParams, Participants, Session, GroupParticipants) {
        let collectorId = Session.collector.id;
        let conversationId;
        let appointmentId;
        let read = 'True';
        let page = $stateParams.page;
        let sort = 'last_message_date';
        let lastMessage = 'notnull';
        return Participants
        .get(
        conversationId,
        appointmentId,
        collectorId,
        read,
        page,
        sort,
        lastMessage)
        .then(function(participants) {
          participants.results = GroupParticipants.group(participants.results);
          return participants;
        });
      },
      messagesType: function() {
        return 'archive';
      },
      $title: () => 'Messages - Archive'
    },
    bindings: {
      $transition$: '<'
    }
  });
});



// WEBPACK FOOTER //
// ./routes/messages/index.js